/**
 * Edit-portrait routing: the survey screens are reused to change saved answers,
 * so they carry a flag that keeps the buddy-matching and AI-buddy steps out of
 * the flow and sends the member back to the portrait when they save.
 */
const EDIT_PARAM = 'edit';
const EDIT_VALUE = '1';

export const PORTRAIT_PATH = '/profile/portrait';

export const isPortraitEditMode = (params: URLSearchParams): boolean =>
  params.get(EDIT_PARAM) === EDIT_VALUE;

/** Keeps the edit flag on a survey path while stepping through the questions. */
export const withEditFlag = (path: string, isEdit: boolean): string =>
  isEdit ? `${path}?${EDIT_PARAM}=${EDIT_VALUE}` : path;
